import './utils/sentry';
import './polyfill';
import './i18n/i18n';
import { createRoot } from 'react-dom/client';
import { App } from './App';

export async function start({ apiUrl }: { apiUrl: string }) {
  if (import.meta.env.MODE === 'test') {
    const { worker } = await import('./mocks/browser');
    await worker.start();
  }

  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App apiUrl={apiUrl} />);
  }
}
